import React from 'react'
import CrazyEgg from '@/utils/CrazyEgg'
import updateConcourseDates from '@/utils/updateConcurseDates'
import PageLayout from '@/components/templates/page-layout/page-layout'
import TermsSection from '@/components/organisms/terms-section/terms-section'
import MiddleSection from '@/components/organisms/middle-section/middle-section'
import BottomSection from '@/components/organisms/bottom-section/bottom-section'
import FirstSection from '@/components/organisms/first-section/first-section'
import usePageViewTag from '@/hooks/usePageViewTag'
import AppMenu from '@/components/atoms/app-menu/app-menu'
import { HAVE_TOP } from '@/constants/activity-constants'

CrazyEgg()
updateConcourseDates()

const links: Record<string, string> = {
  inicio: 'Inicio',
  about: 'Tu Misión',
}
if (HAVE_TOP) {
  links.top = 'Top Jugadoras'
}
function IndexPage() {
  usePageViewTag()

  return (
    <PageLayout>
      <AppMenu links={links} />
      <FirstSection id="inicio" />
      <MiddleSection id="about" />
      {HAVE_TOP && <BottomSection id="top" />}
      <TermsSection />
    </PageLayout>
  )
}

export default IndexPage
